import { Coins, CreditCard, ArrowUp } from "lucide-react";
import { useCurrencyDetection } from "@/hooks/use-currency-detection";

interface PurchaseBreakdownProps {
  originalPrice: number;
  creditsUsed: number;
  finalPrice: number;
  creditsEarned: number;
}

export function PurchaseBreakdown({
  originalPrice,
  creditsUsed,
  finalPrice,
  creditsEarned
}: PurchaseBreakdownProps) {
  const { formatPrice } = useCurrencyDetection();
  return (
    <div className="rounded-xl p-6 border border-white/10 bg-slate-950/90 backdrop-blur-md">
      <h3 className="text-xl font-display font-semibold text-white mb-4">Purchase Summary</h3>
      
      <div className="space-y-3">
        {/* Original Price */}
        <div className="flex items-center justify-between">
          <span className="text-white/70">Original Price</span>
          <span className="text-white font-medium">{formatPrice(originalPrice)}</span>
        </div>

        {/* Credits Discount */}
        {creditsUsed > 0 && <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 text-yellow-400">
              <Coins className="w-4 h-4" />
              <span>Credits Discount</span>
            </div>
            <span className="text-yellow-400 font-medium">-{formatPrice(creditsUsed)}</span>
          </div>}

        {/* Divider */}
        <div className="border-t border-white/10 my-3"></div>

        {/* Final Total */}
        <div className="flex items-center justify-between text-lg">
          <div className="flex items-center gap-2">
            <CreditCard className="w-5 h-5 text-blue-400" />
            <span className="text-white font-display font-semibold">Total to Pay</span>
          </div>
          <span className="text-blue-400 font-bold text-xl">{formatPrice(finalPrice)}</span>
        </div>

        {/* Credits Earned */}
        {creditsEarned > 0 && <>
            <div className="border-t border-white/10 my-3"></div>
            <div className="bg-emerald-500/20 rounded-lg p-3 border border-emerald-500/30">
              <div className="flex items-center gap-2 text-emerald-400 mb-1">
                <ArrowUp className="w-4 h-4" />
                <span className="font-display font-medium">You'll Earn</span>
              </div>
              <p className="text-white">
                <span className="font-bold text-emerald-400">{creditsEarned} credits</span> added to your account
              </p>
              <p className="text-white/60 text-xs mt-1">
                Use credits for future purchases (1 credit = $1 discount)
              </p>
            </div>
          </>}
      </div>
    </div>
  );
}
